var map = {
	"./item_1.png": 1487,
	"./item_10.png": 319,
	"./item_2.png": 9028,
	"./item_3.png": 157,
	"./item_4.png": 7362,
	"./item_5.png": 1019,
	"./item_6.png": 5616,
	"./item_7.png": 1369,
	"./item_8.png": 9454,
	"./item_9.png": 9447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6939;